<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>عملاء بدون عقود صيانه</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                          هنا يتم عرض العملاء بدون عقود صيانه بدلالة تاريخ آخر عرض
                              <div class='pull-left' style='padding=0px'>
                                <button v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                  <b> طباعة </b>
                                </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                                  <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                  </ul>
                                </div>
                                  <div class='col-lg-2 col-md-4 col-sm-6'>
                                  <div class="form-group input-group">
                                      <span class="input-group-addon">الفرع</span>
                                      <select  @change='FillItineraries()' class="form-control" style="padding: 0px" v-model="brancheID">
                                        <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                          {{ item.name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class='col-lg-10 col-md-8 col-sm-6'>
                                    <div class="form-group">
                                      <div class='form-group input-group'>
                                        <span class="input-group-addon" style="padding: 3px">الخطوط:</span>

                                        <div class="form-group" ref="dropdown" style="position: relative;">
                                          <button @click="toggleDropdown" class="btn btn-light form-control text-right" type="button">
                                            {{ selectedLine.length > 0
                                                ? getSelectedText()
                                                : '' }}
                                          </button>

                                          <div v-if="showDropdown" class="dropdown-menu show"
                                               style="width: 100%; max-height: 300px; overflow-y: auto; padding: 10px; position: absolute; top: 100%; right: 0; z-index: 1000;">
                                            <div class="d-flex justify-content-between mb-2">
                                              <button class="btn btn-sm btn-outline-primary" @click="selectAll">تحديد الكل</button>
                                              <button class="btn btn-sm btn-outline-danger" @click="clearAll">مسح الكل</button>
                                            </div>
                                            <div v-for="item in lines" :key="item.id" class="dropdown-item">
                                              <label class="d-block">
                                                <input  @click="FillRegions($event)" type="checkbox" :value="item.id" v-model="selectedLine" style="margin-left: 5px;">
                                                {{ item.name }}
                                              </label>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                  <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px">
                                  <div class="form-group input-group">
                                      <span class="input-group-addon">المنطقة</span>
                                      <select class="form-control" style="padding: 0px" v-model="region_id">
                                        <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                                          {{ item.region_name }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class='col-lg-3 col-sm-3'>
                                  <div class="form-group input-group">
                                      <span class="input-group-addon">من</span>
                                      <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='date_from'></Datepicker>
                                  </div>
                                  </div>
                                  <div class='col-lg-3 col-sm-3'>
                                  <div class="form-group input-group">
                                      <span class="input-group-addon">الى</span>
                                      <Datepicker :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='date_to'></Datepicker>
                                  </div>
                                  </div>
                                  <div class='col-lg-3 col-sm-3'>
                                    <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                      <b> عرض </b>
                                    </button>
                                  </div>
                                    <div id="contentToPrint">
                                      <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                          <thead>
                                            <tr>
                                              <th style='padding:2px;text-align: center'>م</th>
                                              <th style='padding:2px;text-align: center'>الكود</th>
                                              <th style='padding:2px;text-align: center'>الاسم</th>
                                              <th style='padding:2px;text-align: center'>الخط</th>
                                              <th style='padding:2px;text-align: center'>المنطقة</th>
                                              <th style='padding:2px;text-align: center'>التاريخ</th>
                                              <th style='padding:2px;text-align: center'>منذ</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                              <tr class='odd gradeX' v-for='(record,index) in record' :key='record.id'>

                                                 <td align='center'>{{index +1 }}</td>
                                                 <td align='center'>{{record.rec_id}}</td>
                                                 <td align='right'>{{record.name}}</td>
                                                 <td align='center'>{{record.itinerarie_name}}</td>
                                                 <td align='center'>{{record.region_name}}</td>
                                                 <td align='center'>{{record.offer_date}}</td>
                                                 <td align='center'>{{record.days_from_last_offer}}</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- /.container-fluid -->
        </div>
</template>
<style media="screen">
  .text-green {
    color: green;
  }
  .text-red {
    color: red;
  }
  .text-black {
    color: black;
  }
  .noselect {
    user-select: none;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* IE/Edge */
  }
  button.form-control {
  position: relative;
  padding-right: 30px; /* مساحة للسهم */
  text-align: right;
  cursor: pointer;
  border: 1px solid #ced4da; /* تصميم إطار مثل input */
  border-radius: 4px;
  background-color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  }
  button.form-control::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transform: translateY(-50%);
  }
  button.form-control:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
  }
</style>
<script>
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'Withoutoffers',
  components: {
    tbDate,
    Datepicker
  },
  data () {
    return {
      emptyRec: [{id: 0, name: 0}],
      brancheID: 0,
      itinerarie: 0,
      branches: {},
      ar: ar,
      today: true,
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      date_from: '',
      date_to: '',
      region_id: {},
      regions: '',
      record: {},
      lines: {},
      line: '',
      validationErrors: '',
      selectedLine: [],
      isLoadingData: false,
      showDropdown: false
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  mounted: function () {
    document.addEventListener('click', this.handleClickOutside)
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.FillItineraries()
  },
  methods: {
    // =====================================================
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    // =====================================================
    getSelectedText () {
      const names = this.selectedLine.map(this.getNameById)
      const visibleNames = names.slice(0, 5)
      const extraCount = names.length - visibleNames.length
      return extraCount > 0
        ? `${visibleNames.join('، ')}، و${extraCount} أخرى`
        : visibleNames.join('، ')
    },
    // =====================================================
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },
    // =====================================================
    getNameById (id) {
      const item = this.lines.find(g => g.id === id)
      return item ? item.name : ''
    },
    // =====================================================
    selectAll () {
      this.selectedLine = this.lines.map(item => item.id)
    },
    // =====================================================
    clearAll () {
      this.selectedLine = []
    },
    // =====================================================
    handleClickOutside (event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.showDropdown = false
      }
    },
    // =====================================================
    FillItineraries () {
      this.line = ''
      this.regions = ''
      this.region_id = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
      if (i > -1) {
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.line = 0
      }
    },
    // =====================================================
    FillRegions (e) {
      this.$nextTick(() => {
        var id = (this.selectedLine[0])
        this.regions = ''
        this.region_id = ''
        if (id != null && id.length !== 0) {
          let r = this.branches.findIndex(x => x.id === parseInt(this.brancheID))
          let i = this.branches[r].itineraries.findIndex(x => x.id === parseInt(id))
          if (i > -1) {
            this.regions = JSON.parse(JSON.stringify(this.branches[r].itineraries[i].regions))
            this.regions.unshift(this.emptyRec)
          }
        }
      })
    },
    // =====================================================
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'customer-without-offers', {
        token: localStorage.getItem('token'),
        branch_id: this.brancheID,
        from: this.date_from,
        to: this.date_to,
        region_id: this.region_id,
        selectedLine: this.selectedLine
      })
        .then(({ data }) => {
          this.record = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    }
    // =====================================================
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/Withoutoffers.vue